<mat-card class="card-style px-6 py-6 pt-0 h-full">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Recusar solicitação</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>
  <div class="mt-5 container mx-auto">
    <mat-card class="card-style px-4 py-4">
      <div class="flex justify-between gap-2">
        <div><strong>Origem:</strong> {{ item.origem ?? '-' }}</div>
        <div><strong>Destino:</strong> {{ item.destino ?? '-' }}</div>
      </div>
      <div class="flex justify-between gap-2 mt-3">
        <div><strong>Serviço:</strong> {{ item.tipoServico ?? '-' }}</div>
        <div>
          <strong>Período:</strong> {{ item.dataInicio ?? '-' }} -
          {{ item.dataFinal ?? '-' }}
        </div>
      </div>
    </mat-card>

    <div [formGroup]="form" class="flex gap-4 py-2 px-6 mt-4 items-center">
      <mat-form-field
        class="input-tg w-full px-2 no-message-new"
        appearance="outline"
      >
        <mat-label>Motivo da recusa</mat-label>
        <mat-select formControlName="motivoSelected">
          @for (reason of listReason; track reason) {
            <mat-option [value]="reason.id">
              {{ reason.descricao }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if (!loadingReason && listReason.length == 0) {
      <div class="px-6 text-sm text-gray-600">
        Nenhum motivo cadastrado. Cadastre em Cadastro > Motivos Recusa Cotação.
      </div>
    }

    <div class="flex justify-end gap-4 py-2 px-6 mt-6 items-center">
      <button mat-flat-button class="btn-tg-cancel w-1/5" (click)="close()">
        Cancelar
      </button>
      <button
        mat-flat-button
        class="btn-tg w-1/5"
        [disabled]="form.invalid || loading"
        (click)="refuseRequest()"
      >
        @if (loading) {
          <mat-spinner diameter="22" class="loading-spinner"></mat-spinner>
        } @else {
          Recusar
        }
      </button>
    </div>
  </div>
</mat-card>
